import * as React from "react";
const SvgFiRrCassetteVhs = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19 3H5C2.24 3 0 5.24 0 8v8c0 2.76 2.24 5 5 5h14c2.76 0 5-2.24 5-5V8c0-2.76-2.24-5-5-5m3 13c0 1.65-1.35 3-3 3H5c-1.65 0-3-1.35-3-3V8c0-.35.07-.69.18-1h19.64c.11.31.18.65.18 1zm-4.52-7H6.52c-.71 0-1.37.38-1.72.98-.37.63-.8 1.66-.8 3.02s.44 2.39.8 3.02c.35.61 1.01.98 1.72.98h10.95c.71 0 1.37-.38 1.72-.98.37-.63.8-1.66.8-3.02s-.44-2.39-.8-3.02c-.35-.61-1.01-.98-1.72-.98zM14 10.99V15h-4v-4.01zm-8 2c0-.91.29-1.6.52-2H8V15H6.53c-.24-.41-.53-1.1-.53-2.01m11.48 2H16v-4.01h1.47c.24.41.53 1.1.53 2.01s-.29 1.6-.52 2"
    />
  </svg>
);
export default SvgFiRrCassetteVhs;
